import { Link } from "react-router-dom";

export default function IndexVariants() {
  return (
    <>
      <h3>Variants</h3>
      <Link className="btn btn-primary" to="/variants/create">
        Create Variants{" "}
      </Link>
    </>
  );
}
